const DECIMAL_MOD = 10;

export function roundNumbers(num: number): number {
  return Math.floor(num * DECIMAL_MOD) / DECIMAL_MOD;
}
